const aliases = {
    zh: 'zh-cn',
};
export const getMomentCode = (language) => aliases[language] || language;
